/* vp-ribbon-copy.js -- rewrites the subscription ribbon copy.

   "save 20% on every order"  ->  "plus save an additional 20%"
   (the ribbon is uppercased in CSS, so it reads PLUS SAVE AN ADDITIONAL 20%)

   WHY A SEPARATE FILE
   The string is built in JS, not Liquid -- assets/vp-pdp-2.js for the Vegan
   Protein claude-2 arm and assets/gb-buybox.js for the Daily Greens arm 2, at
   55KB and 37KB. Shopify's theme API replaces whole files (URL-transport
   uploads silently no-op on this store, so TEXT is the only path), which makes
   a one-line copy change a 92KB retype across the two. This does it in 2KB and
   is shared by both.

   THE PERCENTAGE IS NOT HARDCODED. Both engines compute it from Loop's real
   per-delivery price -- rib.textContent = "save " + ribPct + "% on every order"
   -- so this captures whatever number they rendered and puts it back. If the
   Loop plan changes, the ribbon still tells the truth. Hardcoding "20%" here
   would have quietly turned a live figure into a stale claim.

   Both engines rewrite the ribbon on EVERY render (mode switch, add, remove),
   so a one-shot pass is not enough: the observer re-applies, and disconnects
   while writing so it cannot see its own edit. A naive "skip if busy" guard
   drops events that land mid-write, which shows up as the old wording
   reappearing after a fast interaction. */
(function(){
  "use strict";
  var host = document.getElementById("vpRibbon");
  if(!host) return;

  /* Only the engines' exact wording is matched. Anything else -- an already
     rewritten ribbon, or copy someone has since changed -- is left alone, so
     this can never stack "plus save an additional plus save an additional". */
  var FROM = /^\s*save\s+(\d+(?:[.,]\d+)?)\s*%\s*on\s+every\s+order\s*$/i;

  function apply(){
    if(host.hidden) return;
    var m = (host.textContent || "").match(FROM);
    if(!m) return;
    host.textContent = "plus save an additional " + m[1] + "%";
  }

  var obs = new MutationObserver(function(){
    obs.disconnect();
    try { apply(); } catch(e){}
    finally { obs.observe(host, {childList:true, characterData:true, subtree:true}); }
  });

  apply();
  obs.observe(host, {childList:true, characterData:true, subtree:true});

  /* the engines are deferred, so the first paint can land after this parses */
  window.addEventListener("load", apply);
})();